import axios from "axios";
import ConstantList from "../appConfig";
import { getFormData } from "app/common/LocalFunction";

const API_PATH = ConstantList.API_EN_POINT + "/customer-source";
const API_PATH_IMPORT = ConstantList.API_EN_POINT + "/excel";

export const pagingCustomerSource = (searchObject) =>
  axios.post(API_PATH + "/search-by-page", searchObject);

export const getCustomerSourceById = (id) =>
  axios.get(API_PATH + "/get-by-id/" + id);

export const saveCustomerSource = (obj) =>
  axios.post(API_PATH + "/save-or-update", obj);

export const deleteCustomerSource = (id) =>
  axios.delete(API_PATH + "/mark-delete/" + id);

export const importCustomerSourceExcel = (file) => {
  let formData = getFormData({ upload: file });
  let url = API_PATH_IMPORT + "/import-customer-source";
  return axios({
    url: url,
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "*/*",
    },
    method: "POST",
    responseType: "blob",
    data: formData,
  });
};

export const syncCustomerSource = (obj) =>
  axios.post(API_PATH + "/sync-customer-source", obj);

export const getListCode = (searchObject) =>
  axios.post(API_PATH + "/get-list-code", searchObject);
